// Keep this format compatible with the admin preview and the student app.
export function safeMessageUrl(value) {
    if (typeof value !== 'string' || /[\s\u0000-\u001f<>"'`\\]/.test(value)) return null
    // Validate without URL getters, which are incomplete in the native app runtime.
    const match = /^https?:\/\/(\[[0-9a-f:.]+\]|[a-z0-9_\u0080-\uffff](?:[a-z0-9_.\-\u0080-\uffff]*[a-z0-9_\u0080-\uffff])?)(?::(\d{1,5}))?(?:[/?#].*)?$/i.exec(value)
    return match && (!match[2] || Number(match[2]) <= 65535) ? value : null
}

export function parseMessageContent(value) {
    const text = String(value || '')
    const pattern = /\[([^\]\n]+)\]\(([^\s<>()[\]]+)\)|https?:\/\/[^\s<>"'`]+/gi
    const nodes = []
    let end = 0
    for (const match of text.matchAll(pattern)) {
        if (match.index > end) nodes.push({ type: 'text', text: text.slice(end, match.index) })
        const url = match[1] !== undefined ? match[2] : match[0].replace(/[.,;!?)]+$/, '')
        if (safeMessageUrl(url)) {
            nodes.push({ type: 'link', label: match[1] || url, url })
            if (!match[1] && url.length < match[0].length) nodes.push({ type: 'text', text: match[0].slice(url.length) })
        } else nodes.push({ type: 'text', text: match[0] })
        end = match.index + match[0].length
    }
    if (end < text.length) nodes.push({ type: 'text', text: text.slice(end) })
    return nodes
}

export function messagePlainText(value) {
    return parseMessageContent(value).map(node => node.type === 'text' ? node.text
        : node.label === node.url ? node.url : node.label + ' (' + node.url + ')').join('')
}

const escape = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]))

export function messageHtml(value) {
    return '<div style="font-family:Arial,sans-serif;font-size:15px;line-height:1.6;overflow-wrap:anywhere">' + parseMessageContent(value).map(node =>
        node.type === 'text' ? escape(node.text).replace(/\r?\n/g, '<br>')
            : `<a href="${escape(node.url)}" target="_blank" rel="noopener noreferrer" style="color:#c2410c;text-decoration:underline">${escape(node.label)}</a>`
    ).join('') + '</div>'
}


export function splitMessageAttachments(value) {
    const attachments = []
    const message = String(value || '').replace(/\[([^\]\n]+)\]\(([^\s<>()[\]]+)\)/g, (source, label, url) => {
        if (!/^https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/MessageAttachments%2F/i.test(url) || !safeMessageUrl(url)) return source
        if (!attachments.some(item => item.url === url)) attachments.push({ label, url })
        return ''
    }).trimEnd()
    return { message, attachments }
}

export function joinMessageAttachments(message, attachments = []) {
    const text = String(message || '').trimEnd()
    const files = attachments.map(item => `[${item.label}](${item.url})`).join('\n')
    return text + (text && files ? '\n\n' : '') + files
}
